module.exports = __webpack_public_path__ + "static/img/brees-2013-img-in-copy.a3e4617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-img-in-copy.jpg
// module id = 3AEd
// module chunks = 1